export default __webpack_public_path__ + "assets/b7cd0fae8a637835600dc15164b44df8.png";